import { Grid, MultiSelect, Text } from "designSystem/index";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";
import React from "react";
import { sortedByGroupItems as originalItems } from "designSystemLegacy/data";
import { cloneDeep } from "lodash";
import { getNoneComponentItem } from "designSystem/utilities/component-item-functions";
import { useLocale } from "designSystem/locale";

const groupedItems = cloneDeep(originalItems);

const values = groupedItems.slice(0, 2);

const itemsWithEmptyGroup = cloneDeep(originalItems);
itemsWithEmptyGroup.forEach((item) => item.group = item.group === "CA" ? "" : item.group);
const valuesEmptyGroup = groupedItems.slice(1, 2);

items[3].disabled = true;

export default () => {
	const loc = useLocale();
	const itemsWithNone = [getNoneComponentItem(loc)].concat(items);
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="With Chips" />
			<MultiSelect
				options={items}
				selectAll
				value={[items[0]]}
			/>
			<Text semiBold text="No Chips" />
			<MultiSelect
				noChips
				options={items}
				selectAll
				value={[items[0], items[3]]}
			/>
			<Text semiBold text="Limits" />
			<MultiSelect
				limitTags={2}
				options={items}
				selectAll
				value={[items[3]]}
			/>
			<Text semiBold text="Items with NONE" />
			<MultiSelect
				options={itemsWithNone}
				selectAll
				value={[]}
			/>
			<Text semiBold text="No Initial selection" />
			<MultiSelect
				options={items}
				selectAll
				value={[]}
			/>
			<Text semiBold text="Allow Custom Options" />
			<MultiSelect
				allowCustomOptions
				options={items}
				selectAll
				value={[items[0]]}
			/>
			<Text semiBold text="normal" />
			<Text semiBold text="suggested" />
			<MultiSelect
				grouped
				options={groupedItems}
				selectAll
				value={values}
			/>
			<MultiSelect
				grouped
				options={groupedItems}
				selectAll
				suggestedGroups={[ "CA", "WA" ]}
				value={values}
			/>
			<Text semiBold text="custom options" />
			<Text semiBold text="some ungrouped items" />
			<MultiSelect
				allowCustomOptions
				grouped
				options={groupedItems}
				selectAll
				value={values}
			/>
			<MultiSelect
				grouped
				options={itemsWithEmptyGroup}
				selectAll
				value={valuesEmptyGroup}
			/>		
		</CssColumnGrid>
	);
};